import { render, staticRenderFns } from "./SupplementEdit.vue?vue&type=template&id=8367e1c8&scoped=true"
import script from "./SupplementEdit.vue?vue&type=script&lang=js"
export * from "./SupplementEdit.vue?vue&type=script&lang=js"
import style0 from "./SupplementEdit.vue?vue&type=style&index=0&id=8367e1c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8367e1c8",
  null
  
)

export default component.exports